import React, { useEffect, useState } from "react";
import { Card, Spin, message, Collapse, Typography, Empty, Tag } from "antd";
import axios from "axios";
import SummaryApi from "../common/index";
import "../Styles/UserStylings/RepliedQueries.css";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const RepliedQueries = () => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRepliedQueries = async () => {
    setLoading(true);
    try {
      const res = await axios.get(SummaryApi.getRepliedQueries.url, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        withCredentials: true,
      });

      const queriesData = res.data?.queries || [];

      const mappedQueries = await Promise.all(
        queriesData.map(async (q) => {
          try {
            const msgRes = await axios.get(
              SummaryApi.getQueryMessages(q.query_id).url,
              {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
              }
            );
            return { ...q, messages: msgRes.data?.messages || [] };
          } catch {
            return { ...q, messages: [] };
          }
        })
      );

      setQueries(mappedQueries);
    } catch (err) {
      console.error("Error fetching replied queries:", err);
      message.error("Failed to fetch replied queries");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepliedQueries();
  }, []);

  if (loading)
    return (
      <div className="repliedqueries-loading">
        <Spin size="large" tip="Loading replied queries..." />
      </div>
    );

  if (!queries.length)
    return (
      <div className="repliedqueries-empty">
        <Empty description="No replied queries yet." />
      </div>
    );

  return (
    <div className="repliedqueries-container">
      <Title level={3} className="repliedqueries-title">
        Replied Queries
      </Title>
      <div className="repliedqueries-grid">
        {queries.map((q) => (
          <Card
            key={q.query_id}
            className="repliedqueries-card"
            title={<Text strong className="query-subject">{q.subject}</Text>}
            bordered={false}
            hoverable
          >
            <div className="query-details">
              <p><b>Category:</b> {q.category}</p>
              <p>
                <b>Priority:</b>{" "}
                <Tag color={q.priority === "High" ? "red" : q.priority === "Medium" ? "orange" : "green"}>
                  {q.priority}
                </Tag>
              </p>
              <p>
                <b>Status:</b>{" "}
                <Tag color={q.status === "Resolved" ? "green" : q.status === "Pending" ? "orange" : "blue"}>
                  {q.status}
                </Tag>
              </p>
              <p><b>Order Number:</b> {q.order_number || "N/A"}</p>
              <p><b>Seller’s Latest Reply:</b> {q.reply}</p>
              <p className="reply-date">
                <b>Reply At:</b> {new Date(q.reply_at).toLocaleString()}
              </p>
            </div>

            <Collapse ghost className="message-collapse">
              {q.messages.map((msg) => (
                <Panel
                  header={
                    <div className="message-header">
                      <span className="sender-name">{msg.sender_name}</span>{" "}
                      <span className="sender-role">({msg.sender_role})</span>{" "}
                      <span className="message-time">
                        {new Date(msg.created_at).toLocaleString()}
                      </span>
                    </div>
                  }
                  key={msg.id}
                >
                  <p className="message-text">{msg.message}</p>
                </Panel>
              ))}
            </Collapse>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RepliedQueries;
